<template>
  <div>
    <BasicNavigation></BasicNavigation>
  </div>
  <div class="mx-auto min-h-screen py-10 bg-white px-4 sm:px-6 mx-auto w-10/12">
    <!-- Main container -->
    <div class="flex flex-col sm:flex-row items-start sm:items-stretch sm:gap-10">
      <div class="w-1/6 text-left"></div>
      <!-- Progress bar -->
      <div class="w-auto sm:w-1/6 flex-shrink-0 sm:ml-10 mr-4 mb-6">
        <AccountRegistrationProgressBar :stepCompleted="currentStep.step" />
      </div>
      <!-- Content -->
      <div class="w-full sm:w-5/6 lg:w-1/2 flex-grow max-w-2xl lg:max-w-2xl">
        <card class="w-full">
          <div class="flex items-center gap-2 sm:gap-4 w-full justify-between">
            <div class="flex items-center gap-2 sm:gap-4">
              <ListBulletIcon class="h-6 w-6 text-pdsPrimaryColor flex-shrink-0" />
              <div class="font-bold text-2xl sm:text-xl leading-snug text-pdsPrimaryColor">Uit het register</div>
            </div>
            <div
              v-if="currentStep.step > 0"
              class="cursor-pointer text-pdsPrimaryColor text-sm leading-6 font-semibold"
              @click="editSearchDeatil"
            >
              Wijzigen
            </div>
          </div>
          <div class="mt-2" v-if="currentStep.step > 0">
            <label class="font-bold text-sm leading-6 text-cyan-900" v-if="fields.bigCode">
              Big-nummer: <span class="text-sm leading-6">{{ fields.bigCode }}</span>
            </label>
            <label class="font-bold text-sm leading-6 text-cyan-900" v-if="fields.agbCode">
              AGB-code: <span class="text-sm leading-6">{{ fields.agbCode }}</span>
            </label>
            <label class="font-bold text-sm leading-6 text-cyan-900" v-if="fields.agbOrBigCode">
              <span class="text-sm leading-6">{{ fields.agbOrBigCode }}</span>
            </label>
          </div>
          <div v-if="currentStep.step == 0">
            <template v-if="showAgbCodeFields">
              <div class="mt-2 flex flex-col">
                <label class="font-bold text-sm leading-6 text-cyan-900"> Wat is uw persoonlijke AGB-code? </label>
                <input-groups
                  id="agbCode"
                  customClass="w-1/2 sm:w-full !disabled:bg-gray-300 disabled:text-gray-500 disabled:border-gray-300 disabled:cursor-default"
                  :disabled="showBigCodeFields"
                  v-model="fields.agbCode"
                  placeholder="AGB-nummer"
                  :rules="fields.agbCodeValidation.rule"
                  @input="validateForm"
                  :errorWrapper="false"
                />
                <Alert
                  class="mt-2 w-[32rem] max-w-full"
                  v-if="errorMessage.show && showAgbCodeFields && !showBigCodeFields"
                  :html="true"
                  :type="errorMessage.type"
                  :htmlMessage="errorMessage.text"
                />
                <label class="flex items-center font-normal text-sm leading-6 text-gray-700">
                  <input type="checkbox" @input="showInputFields($event.target.checked)" class="mr-2" />
                  Ik heb geen AGB-code.
                </label>
              </div>
            </template>
            <template v-if="showBigCodeFields">
              <div class="mt-2 flex flex-col">
                <label class="font-bold text-sm leading-6 text-cyan-900">Hoe staat u geregistreerd?</label>
                <div class="mt-2">
                  <label class="flex items-center font-normal text-sm leading-6 text-gray-700">
                    <input type="radio" :checked="showBigCodeInput" @click="toggleInput('big')" class="mr-2" />
                    BIG-nummer
                  </label>
                </div>
                <label v-if="showBigCodeInput" class="font-bold text-sm leading-6 text-cyan-900 mt-2">
                  Wat is uw BIG-nummer?
                </label>
                <input-groups
                  v-if="showBigCodeInput"
                  class="w-1/2 sm:w-64"
                  id="bigCode"
                  v-model="fields.bigCode"
                  :rules="{ required: true, regex: /^[0-9]{11}$/ }"
                  placeholder="BIG-nummer"
                  @input="validateForm"
                  :errorWrapper="false"
                />
                <Alert
                  class="mt-2"
                  v-if="errorMessage.show && showBigCodeInput"
                  :html="true"
                  :type="errorMessage.type"
                  :htmlMessage="errorMessage.text"
                />
                <label class="flex items-center font-normal text-sm leading-6 text-gray-700">
                  <input type="radio" :checked="showWarranterFields" @click="toggleInput('warranter')" class="mr-2" />
                  Ik sta niet geregistreerd en sta onder volmacht.
                </label>
              </div>
            </template>
            <template v-if="showWarranterFields">
              <div class="mt-2 flex flex-col text-gray-700">
                <label class="font-bold text-sm leading-6 text-cyan-900 mt-2">
                  Wat is de persoonlijke AGB-code of BIG nummer van de volmachtgever?
                </label>
                <input-groups
                  class="w-1/2 sm:w-64"
                  id="agbOrBigCode"
                  v-model="fields.agbOrBigCode"
                  :rules="{ required: true, regex: /^\d{8}$|^\d{11}$/ }"
                  placeholder="BIG/AGB-nummer"
                  @input="validateForm"
                  :errorWrapper="false"
                />
                <label class="flex items-center font-normal text-sm leading-6 text-gray-700">
                  <input
                    type="checkbox"
                    :checked="showWarranterWarning"
                    @click="setWarranterMessages($event)"
                    class="mr-2"
                  />
                  Volmachtgever heeft geen AGB-code
                </label>
                <Alert
                  v-if="errorMessage.show && showWarranterFields"
                  class="mt-2"
                  :html="true"
                  :htmlMessage="errorMessage.text"
                  :type="errorMessage.type"
                />
              </div>
            </template>
            <div class="pt-2">
              <button
                type="button"
                :class="{
                  'text-white bg-pdsPrimaryColor cursor-pointer border-pdsPrimaryColor': !disableLookUpButton,
                  'text-white  border bg-gray-300 border-gray-300 cursor-default': disableLookUpButton
                }"
                class="text-center rounded-full border w-32 h-10"
                @click.prevent="nextStep()"
              >
                Doorgaan
              </button>
            </div>
          </div>

          <hr class="border-gray-300 mt-2 mb-2" />
          <div class="flex flex-wrap items-center justify-between">
            <div class="flex items-center sm:gap-4">
              <UserIcon
                :class="currentStep.step > 0 ? 'text-pdsPrimaryColor' : 'text-gray-300'"
                class="h-6 w-6 flex-shrink-0"
              />
              <div
                :class="currentStep.step > 0 ? 'text-pdsPrimaryColor' : 'text-gray-300'"
                class="font-bold text-xl leading-snug"
              >
                Contactgegevens
              </div>
            </div>
            <div
              v-if="currentStep.step > 0 && !showEditPrescriberDetails"
              class="cursor-pointer text-pdsPrimaryColor text-sm font-semibold"
              @click="editPersonalDetails"
            >
              Wijzigen
            </div>
            <div v-if="!showEditPrescriberDetails" class="w-full mx-1">
              <div class="text-black">
                <div class="py-1" v-if="currentStep.step > 0">
                  <span v-if="prescriberRegistrationDetails.gender === '1'">Dhr. </span>
                  <span v-if="prescriberRegistrationDetails.gender === '2'">Mevr. </span>
                  <span>
                    {{ prescriberRegistrationDetails.initials || '' }}
                    {{ prescriberRegistrationDetails.initials && prescriberRegistrationDetails.firstName ? ' ' : '' }}
                    {{ prescriberRegistrationDetails.firstName || '' }}
                    {{
                      prescriberRegistrationDetails.firstName && prescriberRegistrationDetails.prePosition ? ' ' : ''
                    }}
                    {{ prescriberRegistrationDetails.prePosition || '' }}
                    {{
                      (prescriberRegistrationDetails.firstName || prescriberRegistrationDetails.prePosition) &&
                      prescriberRegistrationDetails.lastName
                        ? ' '
                        : ''
                    }}
                    {{ prescriberRegistrationDetails.lastName || '' }}
                  </span>

                  <div v-if="prescriberRegistrationDetails.mobileNumber">
                    {{ prescriberRegistrationDetails.mobileNumber }}
                  </div>
                  <div v-if="prescriberRegistrationDetails.dateOfBirth">
                    {{ prescriberRegistrationDetails.dateOfBirth }}
                  </div>
                  <div v-if="prescriberRegistrationDetails.email">
                    {{ prescriberRegistrationDetails.email }}
                  </div>
                </div>
                <div class="py-1" v-if="currentStep.step == 1">
                  <label class="font-bold text-sm leading-6 text-gray-700">Persoonlijke e-mailadres*</label>
                  <input-groups
                    class="w-2/3 sm:w-64"
                    id="code"
                    v-model="fields.email"
                    :rules="{ required: true, isEmail: true }"
                    placeholder="E-mailadres"
                    @input="validateContactForm"
                    :errorWrapper="false"
                  />
                  <div v-if="showUserEmailExistAlert" class="text-sm text-red-600">
                    <span>
                      *Er is al een account geregistreerd met dit e-mailadres. Registreer met een ander e-mailadres of
                      neem
                      <a
                        href="https://mediq.nl/contact/zorgprofessional"
                        target="_blank"
                        class="font-semibold underline decoration-2 underline-offset-4 mt-1"
                      >
                        <u>contact op</u>
                      </a>
                      om toegang tot dit account te krijgen.
                    </span>
                  </div>
                  <div>
                    <button
                      type="button"
                      :class="{
                        'text-white bg-pdsPrimaryColor cursor-pointer border-pdsPrimaryColor': !disableNextButton,
                        'text-white bg-gray-300 border-gray-300 cursor-default': disableNextButton
                      }"
                      class="text-center mt-4 rounded-full border w-32 h-10"
                      @click.prevent="savePrescriberContactDetails()"
                    >
                      Doorgaan
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <AccountRegistrationPrescriberDetail
              :details="prescriberRegistrationDetails"
              @set-prescriber-details="savePrescriberContactDetails"
              v-if="showEditPrescriberDetails"
            >
            </AccountRegistrationPrescriberDetail>
          </div>

          <hr class="border-gray-300 mt-2 mb-2" />
          <AccountRegistrationInstitutionDetail
            :details="prescriberRegistrationDetails"
            :step="currentStep.step"
            :lookup-code-type="lookUpPharseType"
            @set-institution-details="setNextStep"
          >
          </AccountRegistrationInstitutionDetail>
          <hr class="border-gray-300 mt-2 mb-2" />
          <AccountRegistrationRoleDetail
            :details="prescriberRegistrationDetails"
            :step="currentStep.step"
            @set-role-details="setNextStep"
          >
          </AccountRegistrationRoleDetail>
          <hr class="border-gray-300 mt-2 mb-2" />
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import AccountRegistrationProgressBar from '@/components/sections/prescriber/accountRegistration/AccountRegistrationProgressBar';
import BasicNavigation from '@/components/webcomponents/BasicNavigation';
import AccountRegistrationPrescriberDetail from '@/components/sections/prescriber/accountRegistration/AccountRegistrationPrescriberDetail';
import AccountRegistrationInstitutionDetail from '@/components/sections/prescriber/accountRegistration/AccountRegistrationInstitutionDetail';
import AccountRegistrationRoleDetail from '@/components/sections/prescriber/accountRegistration/AccountRegistrationRoleDetail';
import { ListBulletIcon, UserIcon } from '@heroicons/vue/24/outline';
import { useForm } from 'vee-validate';
import { ref, computed, nextTick, watch, getCurrentInstance } from 'vue';
import { useStore } from 'vuex';
import router from '@/router';
import axios from 'axios';
export default {
  name: 'AccountRegistrationCodeLookUp',
  components: {
    AccountRegistrationProgressBar,
    AccountRegistrationPrescriberDetail,
    AccountRegistrationInstitutionDetail,
    AccountRegistrationRoleDetail,
    UserIcon,
    ListBulletIcon,
    BasicNavigation
  },

  setup() {
    const { validate } = useForm();
    const store = useStore();
    const nextStepClicked = ref(false);
    const codeLookup = ref(false);
    const showNoWarranterExistWarning = ref(false);
    const showAgbCodeFields = ref(true);
    const showBigCodeFields = ref(false);
    const showBigCodeInput = ref(false);
    const showWarranterFields = ref(false);
    const showContactDetails = ref(true);
    const showEditPrescriberDetails = ref(false);
    const editSearch = ref(false);
    const showWarranterWarning = ref(false);
    const lookUpPharseType = ref(null);
    const showUserEmailExistAlert = ref(false);
    const disableLookUpButton = ref(true);
    let isInitialRun = true;
    const $emitter = getCurrentInstance().appContext.config.globalProperties.$emitter;
    const savePrescriberRegistration = () => store.dispatch('accountRegistration/savePrescriberRegistration');
    const currentStep = ref({
      step: 0,
      status: ''
    });
    const errorMessage = ref({
      text: '',
      type: '',
      show: false
    });
    const prescriberRegistrationDetails = computed(
      () => store.getters['accountRegistration/getPrescriberRegistrationDetails']
    );

    const disableNextButton = computed(() => {
      if (prescriberRegistrationDetails.value.email) {
        return !validateContactForm();
      }
      return true;
    });

    const fields = computed(() => store.state.accountRegistration.prescriberRegistrationDetails);
    fields.value.agbCodeValidation = {
      rule: {
        required: true,
        regex: /^[0-9]{8}$/
      }
    };
    const savePrescriberContactDetails = async () => {
      const result = await validate();
      if (result.valid) {
        axios.get('Registration/IsUserEmailAlreadyExists?email=' + fields.value.email).then((response) => {
          if (response.data.data == false) {
            errorMessage.value.show = false;
            showEditPrescriberDetails.value = false;
            setlookupType();
            getStepVisibilityStatus(2);
            showUserEmailExistAlert.value = false;
          } else {
            showUserEmailExistAlert.value = true;
          }
        });
      }
    };
    const setNextStep = (step) => {
      errorMessage.value.show = false;
      getStepVisibilityStatus(step);
      if (step == 4) {
        saveRegistration();
      }
    };
    const validateContactForm = async () => {
      let result = await validate();
      if (result.valid) {
        return true;
      } else {
        return false;
      }
    };
    const nextStep = async () => {
      if (fields.value.agbCode || fields.value.bigCode || fields.value.agbOrBigCode) {
        const result = await validate();
        if (result.valid) {
          codeLookUp();
        }
      } else {
        nextStepClicked.value = true;
        setTimeout(() => {
          validateAllFields();
        }, 2000);
      }
    };

    const showInputFields = (isSelected) => {
      disableLookUpButton.value = true;
      if (isSelected) {
        fields.value.agbCodeValidation.rule = { required: false };
        fields.value.agbCode = '';
        fields.value.agbOrBigCode = '';
        showWarranterFields.value = false;
        showBigCodeFields.value = true;
        errorMessage.value.show = false;
      } else {
        fields.value.agbCodeValidation.rule = { required: true, regex: /^[0-9]{8}$/ };
        showBigCodeFields.value = false;
        showBigCodeInput.value = false;
        showWarranterFields.value = false;
        fields.value.bigCode = '';
        fields.value.agbOrBigCode = '';
        resetCustomErrorMessages();
      }
    };
    const toggleInput = (key) => {
      if (key == 'big') {
        showBigCodeInput.value = !showBigCodeInput.value;
        if (showBigCodeInput) {
          fields.value.agbOrBigCode = '';
          currentStep.value.step = 0;
          showWarranterFields.value = false;
          showNoWarranterExistWarning.value = false;
          errorMessage.value.show = false;
        }
      }
      if (key == 'warranter') {
        fields.value.agbCode = '';
        fields.value.bigCode = '';
        showWarranterFields.value = !showWarranterFields.value;
        if (showWarranterFields) {
          currentStep.value.step = 0;
          showBigCodeInput.value = false;
          errorMessage.value.show = false;
        }
      }
    };
    const validateAllFields = async () => {
      const result = await validate();
      if (!result.valid) {
        resetCustomErrorMessages();
      }
    };
    const getStepVisibilityStatus = (step) => {
      currentStep.value.step = step;
      currentStep.value.status = 'complete';
    };
    const resetCustomErrorMessages = () => {
      errorMessage.value.show = false;
      showNoWarranterExistWarning.value = false;
      showEditPrescriberDetails.value = false;
      showWarranterWarning.value = false;
    };
    const editPersonalDetails = () => {
      showEditPrescriberDetails.value = true;
      getStepVisibilityStatus(1);
    };
    const editSearchDeatil = () => {
      if (fields.value.agbCode) {
        showAgbCodeFields.value = true;
      } else if (fields.value.bigCode) {
        showBigCodeFields.value = true;
      } else if (fields.value.agbOrBigCode) {
        showWarranterFields.value = true;
      }
      editSearch.value = true;
      resetCustomErrorMessages();
      getStepVisibilityStatus(0);
    };
    const setWarranterMessages = (event) => {
      if (event.target.checked) {
        showWarranterWarning.value = true;
      } else {
        showWarranterWarning.value = false;
        errorMessage.value.show = false;
      }
      if (showWarranterWarning.value) {
        errorMessage.value.text =
          "<span class='text-[#143344]'> Uw volmachtgever heeft een AGB-code nodig om geregisteerd te kunnen worden. Overleg met uw volmachtgever of kijk in het AGB- register.<br> <a href='https://www.vektis.nl/agb-register/zoeken' target='_blank' class='font-bold underline decoration-2 underline-offset-4 mt-1'><u>AGB-register →</u></a><span>";
        errorMessage.value.type = 'info';
        errorMessage.value.show = true;
      }
    };
    const setlookupType = async () => {
      lookUpPharseType.value = null;
      await nextTick();
      lookUpPharseType.value = fields.value.agbCode ? 'agb' : 'big';
      if (fields.value.agbCode) {
        lookUpPharseType.value = 'agb';
      } else if (fields.value.bigCode) {
        lookUpPharseType.value = 'big';
      } else {
        lookUpPharseType.value = 'agbOrBig';
      }
    };
    const codeLookUp = () => {
      codeLookup.value = true;
      let codeDetails = { code: fields.value.agbCode, lookUpPharseType: 'agb' };
      if (!fields.value.agbCode && fields.value.bigCode) {
        codeDetails = { code: fields.value.bigCode, lookUpPharseType: 'big' };
      }
      if (fields.value.agbOrBigCode) {
        codeDetails = { code: fields.value.agbOrBigCode, lookUpPharseType: 'agbOrBig' };
      }
      store.dispatch('accountRegistration/fetchPrescriberAccountDataUsingCode', codeDetails).then((response) => {
        if (response) {
          if (response.IsUserExists == true) {
            if (showWarranterFields.value == true) {
              // allow user to register
              editPersonalDetails.value = true;
              showEditPrescriberDetails.value = true;
              getStepVisibilityStatus(1);
            } else {
              errorMessage.value.text = fields.value.bigCode
                ? "<span class='text-[#143344]'>Dit BIG-nummer bestaat al in onze database. Neem contact op met Mediq om uw account te activeren.<br><a href='https://mediq.nl/contact/zorgprofessional' target='_blank' class='font-bold underline mt-1 decoration-2 underline-offset-4 inline-block'><span class='font-bold'>Contact met Mediq →</span></a></span>"
                : "<span class='text-[#143344]'>Dit AGB code bestaat al in onze database. Neem contact op met Mediq om uw account te activeren. <br><a href='https://mediq.nl/contact/zorgprofessional' target='_blank' class='font-bold underline mt-1 decoration-2 underline-offset-4 inline-block'><span class='font-bold'>Contact met Mediq →</span></a><span>";
              errorMessage.value.type = 'info';
              errorMessage.value.show = true;
              getStepVisibilityStatus(0);
            }
          } else if (
            (response.AllowRegistration == true && response.IsUserExists == false && response.Initials) ||
            (response.AllowRegistration == true && response.IsUserExists == false)
          ) {
            getStepVisibilityStatus(1);
            validateAllFields();
          } else {
            errorMessage.value.text = fields.value.bigCode
              ? "<span class='text-[#143344]'>UW BIG-nummer is onbekend. Neem contact op met het BIG register.</span>"
              : "<span class='text-[#143344]'>Uw AGB-code staat niet in het AGB-register. U kunt zonder AGB-code (of BIG-nummer) alleen onder volmacht een account aanmaken.<br><a href='https://www.vektis.nl/agb-register/zoeken' target='_blank' class='font-bold underline mt-1 decoration-2 underline-offset-4 inline-block'><span class='font-bold'>Check het AGB-register →</span></a></span>";
            if (fields.value.agbOrBigCode) {
              errorMessage.value.text =
                "<span class='text-[#143344]'>Er is geen volmachtgever met dit AGB-code (of BIG-nummer) bij ons bekend. Zorg ervoor dat de volmachtgever al is geregistreerd. Is dit al het geval neem dan <a href='https://mediq.nl/contact/zorgprofessional' target='_blank' class='font-bold underline mt-1 decoration-2 underline-offset-4 inline-block'>contact</a>  op met ons.</span>";
            }
            errorMessage.value.type = 'error';
            errorMessage.value.show = true;
          }
        }
      });
    };
    const saveRegistration = () => {
      savePrescriberRegistration().then((response) => {
        if (response && response.Success) {
          window.dataLayer.push({
            event: 'prescriberRegistration',
            userData: { uuid: response.data.UUID },
            details: 'registrerensucces'
          });
          router.push('/succesvolgeregistreerd');
        } else {
          $emitter.emit('notification', {
            title: 'Er is een fout opgetreden tijdens het verwerken van de registratie van een nieuw account',
            success: false
          });
        }
      });
    };

    const validateForm = async () => {
      if (fields.value.agbCode || fields.value.bigCode || fields.value.agbOrBigCode) {
        let result = await validate();
        if (result.valid) {
          disableLookUpButton.value = false;
        } else {
          disableLookUpButton.value = true;
        }
      } else {
        disableLookUpButton.value = true;
      }
    };
    watch(
      () => fields.value?.email,
      (newVal, oldVal) => {
        if (isInitialRun) {
          isInitialRun = false;
          return;
        }
        if (newVal !== oldVal) {
          showUserEmailExistAlert.value = false;
        }
      }
    );
    return {
      prescriberRegistrationDetails,
      fields,
      savePrescriberContactDetails,
      nextStep,
      codeLookUp,
      validateAllFields,
      showInputFields,
      editSearch,
      showAgbCodeFields,
      editSearchDeatil,
      showBigCodeFields,
      showBigCodeInput,
      toggleInput,
      showWarranterFields,
      showNoWarranterExistWarning,
      showContactDetails,
      currentStep,
      editPersonalDetails,
      showEditPrescriberDetails,
      errorMessage,
      setWarranterMessages,
      showWarranterWarning,
      lookUpPharseType,
      setNextStep,
      showUserEmailExistAlert,
      savePrescriberRegistration,
      disableLookUpButton,
      validateForm,
      disableNextButton
    };
  }
};
</script>
